window.__sccCartCaptureWithoutConsent = true;
window.__sccCartDiagnostics = function () {
    var VERSION = '2';
    var SAFE = /^[A-Za-z0-9_-]{8,512}$/;
    var CLICK_KEYS = ['gclid', 'gbraid', 'wbraid', 'fbclid'];
    var q = location.search;
    var fromUrl = function (k, src) {
      var m = (src === undefined ? q : src).match(new RegExp('[?&]' + k + '=([^&#]+)'));
      try { return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; }
    };
    var cookie = function (n) {
      var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + n + '=([^;]+)'));
      return m ? m[1] : '';
    };
    var cookieByPrefix = function (p) {
      var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + p + '[^=;]*=([^;]+)'));
      return m ? m[1] : '';
    };
    // Google's own first-party cookies look like GCL.<timestamp>.<id>
    var fromGcl = function (n) { var p = cookie(n).split('.'); return p.length >= 3 ? p.slice(2).join('.') : ''; };
    var store = function (area) {
      return {
        get: function (k) { try { return area.getItem('_scc_' + k) || ''; } catch (e) { return ''; } },
        set: function (k, v) { try { area.setItem('_scc_' + k, v); } catch (e) {} }
      };
    };
    var ls = store(window.localStorage), ss = store(window.sessionStorage);
    var cap = function (v, n) { v = String(v == null ? '' : v); n = n || 512; return v.length > n ? v.slice(0, n) : v; };
    var now = new Date().toISOString();
    var attrs = { _scc_v: VERSION, _scc_ts: now };

    // First touch lives in localStorage, the current session in sessionStorage. When storage is
    // unavailable the current page stands in, so the marker and landing are still written.
    // A stale container copy running inside the web-pixel sandbox may have seeded storage with the sandbox
    // URL; the main-page instance repairs that with the real page.
    var polluted = function (v) { return v.indexOf('/web-pixels@') >= 0; };
    if (!ls.get('ft') || polluted(ls.get('lp'))) { ls.set('ft', now); ls.set('lp', cap(location.href)); ls.set('ref', cap(document.referrer)); }
    if (!ss.get('slp') || polluted(ss.get('slp'))) { ss.set('slp', cap(location.href)); ss.set('sref', cap(document.referrer)); }
    if (!ls.get('vid')) { var vid = ''; for (var r = 0; r < 32; r++) vid += Math.floor(Math.random() * 16).toString(16); ls.set('vid', vid); }
    attrs._scc_ft = ls.get('ft') || now; attrs._scc_lp = ls.get('lp') || cap(location.href); attrs._scc_ref = ls.get('ref') || cap(document.referrer);
    attrs._scc_slp = ss.get('slp') || cap(location.href); attrs._scc_sref = ss.get('sref') || cap(document.referrer);
    var vidStored = ls.get('vid'); if (vidStored) attrs._scc_vid = vidStored;
    var lpQuery = attrs._scc_lp.indexOf('?') >= 0 ? attrs._scc_lp.slice(attrs._scc_lp.indexOf('?')) : '';
    var utm = { src: 'utm_source', med: 'utm_medium', cmp: 'utm_campaign', cnt: 'utm_content', trm: 'utm_term' };
    for (var u in utm) { var uv = fromUrl(utm[u], lpQuery); if (uv) attrs['_scc_' + u] = cap(uv, 128); }

    // GA4: _ga = GA1.1.<client>.<ts>; _ga_<stream> = GS1.1.<sid>.<num>... or GS2.1.s<sid>$o<num>$...
    var ga = cookie('_ga').split('.'); if (ga.length >= 4) attrs._scc_ga = cap(ga.slice(2).join('.'), 64);
    var gs = cookieByPrefix('_ga_');
    if (gs) { var gm = gs.match(/^GS2\.\d+\.s(\d+)\$o(\d+)/) || gs.match(/^GS1\.\d+\.(\d+)\.(\d+)/); if (gm) { attrs._scc_gas = gm[1]; attrs._scc_gan = gm[2]; } }
    var fbp = cookie('_fbp'); if (fbp) attrs._scc_fbp = cap(fbp, 64);
    var fbc = cookie('_fbc'); if (fbc) attrs._scc_fbc = cap(fbc, 512);
    // Consent: Pandectes pushes Pandectes_Consent_Update {pandectes_action, pandectes_status, pandectes_categories}
    // into the dataLayer on every page (before any banner interaction); its cookie is the fallback.
    var consent = '';
    try {
      var dl = window.dataLayer || [];
      for (var d = dl.length - 1; d >= 0; d--) {
        var ce = dl[d];
        if (ce && ce.event === 'Pandectes_Consent_Update') {
          var cats = ce.pandectes_categories || {}, parts = [];
          for (var ck in cats) parts.push(ck + '=' + cats[ck]);
          consent = (ce.pandectes_action || '') + ':' + (ce.pandectes_status || '') + ':' + parts.join(',');
          break;
        }
      }
    } catch (e3) {}
    if (!consent) consent = cookie('_pandectes_gdpr');
    if (consent) attrs._scc_consent = cap(consent, 128);

    return attrs;
};
(function () {
  if (location.href.indexOf('/web-pixels@') >= 0 || window.top !== window.self) return;
  if (!window.__sccCartCaptureV3) {
    // Owner-set option (all markets since 17/9): store identifiers on the cart even without
    // marketing permission. Never changes advertising consent: snapshot() stays gated.
    var cartWithoutConsent = window.__sccCartCaptureWithoutConsent === true;
    var keys = ['gclid', 'gbraid', 'wbraid', 'msclkid', 'fbclid'];
    var ttl = 90 * 86400000;
    var safe = /^[A-Za-z0-9_-]{8,512}$/;
    var allowed = function () {
      try { return window.Shopify.customerPrivacy.marketingAllowed() === true; } catch (e) { return false; }
    };
    var cookie = function (name) {
      var rows = document.cookie.split(';');
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i].replace(/^\s+/, '');
        if (row.indexOf(name + '=') === 0) {
          try { return decodeURIComponent(row.slice(name.length + 1)); } catch (e) { return ''; }
        }
      }
      return '';
    };
    var get = function (key) { try { return window.localStorage.getItem('_scc_' + key) || ''; } catch (e) { return ''; } };
    var put = function (key, value) { try { window.localStorage.setItem('_scc_' + key, value); } catch (e) {} };
    var fromQuery = function (key) {
      var rows = location.search.replace(/^\?/, '').split('&'), found = 0, value = '';
      for (var n = 0; n < rows.length; n++) {
        var eq = rows[n].indexOf('='), name = eq < 0 ? rows[n] : rows[n].slice(0, eq);
        try { name = decodeURIComponent(name.replace(/\+/g, ' ')); } catch (e) { continue; }
        if (name !== key) continue;
        found++;
        try { value = eq < 0 ? '' : decodeURIComponent(rows[n].slice(eq + 1).replace(/\+/g, ' ')); } catch (e) { return ''; }
      }
      return found === 1 ? value : '';
    };
    var capture = function () {
      var out = {}, now = Date.now();
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i], url = fromQuery(key), backup = '';
        var platform = '', platformTime = NaN;
        if (key === 'gclid' || key === 'gbraid') {
          var gcl = cookie(key === 'gclid' ? '_gcl_aw' : '_gcl_gb').split('.');
          platform = gcl.slice(2).join('.');
          if (gcl[0] === 'GCL' && /^\d{10}$/.test(gcl[1])) platformTime = Number(gcl[1]) * 1000;
        }
        if (key === 'msclkid') platform = cookie('_uetmsclkid').replace(/^_uet/, '');
        if (key === 'fbclid') platform = cookie('_fbc').split('.').slice(3).join('.');
        var seen = Date.parse(get(key + '_ts'));
        var mirror = isFinite(seen) && now >= seen && now - seen < ttl ? get(key) : '';
        var legacy = '';
        // Migrate the old Microsoft writer's undated mirror once. This timestamp
        // records observation by this script, not an invented ad-click time.
        if (key === 'msclkid' && !get(key + '_ts')) {
          try { legacy = window.localStorage.getItem('_ms_clk') || ''; } catch (e) {}
        }
        // An unchanged cookie predating a URL click must not take over on the next page.
        // Different cookies also need freshness evidence before replacing a recovered backup.
        // Microsoft cookies have no timestamp: a new native/backup URL can still replace them.
        // No advertising cookie is written here.
        var oldCookie = mirror && platform === get(key + '_shadowed_cookie');
        var backupSeen = Date.parse(get(key + '_backup_seen'));
        var freshnessFloor = isFinite(backupSeen) ? Math.max(seen, backupSeen) : seen;
        var unprovenCookie = mirror && platform !== mirror && get(key + '_origin') === 'backup_url' &&
          !(isFinite(platformTime) && platformTime > freshnessFloor && platformTime <= now);
        var candidates = [url, backup, oldCookie || unprovenCookie ? '' : platform, mirror, legacy];
        var sources = ['url', 'backup_url', 'cookie', 'mirror', 'legacy_mirror'];
        for (var j = 0; j < candidates.length; j++) {
          var id = candidates[j];
          if (!safe.test(id) || id === 'undefined') continue;
          if (j < 2) put(key + '_shadowed_cookie', platform !== id ? platform : '');
          if (j === 1) put(key + '_backup_seen', new Date(now).toISOString());
          if (j < 2 || (j !== 3 && id !== get(key))) put(key + '_origin', sources[j]);
          if (id !== get(key) || !isFinite(seen)) put(key + '_ts', new Date(now).toISOString());
          put(key, id);
          out[key] = id;
          out['_scc_' + key + '_src'] = sources[j];
          out['_scc_' + key + '_ts'] = get(key + '_ts') || new Date(now).toISOString();
          break;
        }
      }
      var browserCookies = { _scc_fbp: '_fbp', _scc_fbc: '_fbc', _scc_uetvid: '_uetvid' };
      for (var field in browserCookies) {
        var value = cookie(browserCookies[field]);
        if (/^[A-Za-z0-9_.-]{8,512}$/.test(value)) out[field] = value;
      }
      return out;
    };
    // Existing GTM consumers only receive identifiers with marketing permission.
    var snapshot = function () { return allowed() ? capture() : {}; };
    var consentLabel = function () {
      try {
        var state = window.Shopify.customerPrivacy.marketingAllowed();
        return state === true ? 'shopify:marketing_allowed' : state === false ? 'shopify:marketing_not_allowed' : 'shopify:unavailable';
      } catch (e) { return 'shopify:unavailable'; }
    };
    var busy = false, pending = false;
    var write = function () {
      if (!cartWithoutConsent && !allowed()) return;
      if (busy) { pending = true; return; }
      var captured = capture(), attrs = {};
      // Only the UK supplies its existing experiment diagnostics. One shared
      // writer persists them; storage events get the smaller attribution set.
      try { if (window.__sccCartDiagnostics) attrs = window.__sccCartDiagnostics() || {}; } catch (e) {}
      for (var field in captured) attrs[field] = captured[field];
      attrs._scc_v = '3.4';
      attrs._scc_ts = new Date().toISOString();
      attrs._scc_consent = cartWithoutConsent ? consentLabel() : attrs._scc_consent || consentLabel();
      var root = window.Shopify.routes && window.Shopify.routes.root || '/';
      var xhr = new XMLHttpRequest();
      busy = true;
      xhr.open('POST', root + 'cart/update.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.timeout = 5000;
      var done = function () { busy = false; if (pending) { pending = false; write(); } };
      xhr.onload = done;
      xhr.onerror = done; xhr.ontimeout = done;
      xhr.send(JSON.stringify({ attributes: attrs }));
    };
    window.__sccCartCaptureV3 = { write: write, snapshot: snapshot };
    document.addEventListener('visitorConsentCollected', write);
    if (window.Shopify && !window.Shopify.customerPrivacy && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) write(); });
    }
  }
  window.__sccCartCaptureV3.write();
})();

(function () {
  if (window.top !== window.self) return;
  var write = function () { window.__sccCartCaptureV3.write(); };
  document.addEventListener('submit', function (e) {
    if (e.target.matches && e.target.matches('form[action*="/cart/add"],form[action*="/cart"]')) write();
  }, true);
  document.addEventListener('click', function (e) {
    var target = e.target.closest && e.target.closest('button[name="add"],button[name="checkout"],a[href*="/checkout"],.shopify-payment-button');
    if (target) write();
    var preferences = e.target.closest && e.target.closest('a[href="#reopenBanner"],a[href="#nbb-cookie-preferences"]');
    if (preferences) {
      e.preventDefault();
      if (window.privacyBanner && window.privacyBanner.showPreferences) window.privacyBanner.showPreferences().catch(function () {});
    }
  }, true);
})();
